import ElementUI from 'element-ui'
import axios from 'axios'
import { i18n } from '../i18n'
import router from '@/router'

/* eslint-disable import/order */
// axios

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_HUB_NEXT,

  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    accept: 'application/json'
  }
})

axiosInstance.interceptors.request.use(
  config => {
    // Do something before request is sent

    const accessToken = localStorage.getItem('el_rey_mono_kung_fu')

    if (accessToken && !config.headers['X-NoAuthorization']) {
      config.headers.Authorization = `Bearer ${accessToken}`
      config.headers['X-Apigateway-Api-Userinfo'] = `Bearer ${accessToken}`
    }

    delete config.headers['X-NoAuthorization']

    config.params = {
      ...config.params,
      key: process.env.VUE_APP_API_HUB_KEY
    }

    // config.validateStatus = status => status < 207

    return config
  },
  error => Promise.reject(error)
)

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => {
    if (
      response.status === 200 &&
      response.config &&
      response.config.method === 'post' &&
      !response.config.headers['x-hide-notification']
    ) {
      ElementUI.Message.success(i18n.tc('saved'))
    } else if (
      response.status === 200 &&
      response.config &&
      response.config.method === 'put' &&
      !response.config.headers['x-hide-notification']
    ) {
      ElementUI.Message.success(i18n.tc('saved'))
    } else if (
      response.status === 200 &&
      response.config &&
      response.config.method === 'patch' &&
      !response.config.headers['x-hide-notification']
    ) {
      ElementUI.Message.success(i18n.tc('saved'))
    } else if (
      response.status === 200 &&
      response.config &&
      response.config.method === 'delete' &&
      !response.config.headers['x-hide-notification']
    ) {
      ElementUI.Message.success(i18n.tc('deleted'))
    }

    return response
  },

  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  error => {
    if (error.response && error.response.data && error.response.data.detail) {
      ElementUI.Message.error(error.response.data.detail)
    } else if (error.config && error.config.url.includes('api.ipify')) {
      console.error('api.ipify', error.response)
    } else if (error.isAxiosError && error.response && error.response.data && error.response.data.message) {
      ElementUI.Message.error(error.isAxiosError && error.response.data.message)
    } else if (error.isAxiosError && error.response && error.response.data) {
      ElementUI.Message.error(error.isAxiosError && error.response.data)
    } else if (error) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx

      ElementUI.Message.error(error)

      if (error.isAxiosError && error.response && error.response.status === 401) {
        router.push('/login')
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
    } else {
      // Something happened in setting up the request that triggered an Error
    }

    // Promise.reject(error)
    throw new Error(error)
  }
)

export default axiosInstance
